export default "__VITE_ASSET__BsjmjNzt__"